import { useEffect } from 'react'
import { FlexColumn } from '../../components/atoms/layout/Flex'
import Label from '../../components/atoms/display/Label'
import usePage from '../../hooks/usePage'
import Container from '../../components/atoms/layout/Container'

export default function CompanyRepresentativeCompletedPage() {
  const { changeTitle } = usePage()

  useEffect(() => {
    changeTitle('企業情報', '代表者承認')
  }, [changeTitle])

  return (
    <Container>
      <FlexColumn align="center">
        <Label text="本人確認手続き" variant="title" />
        <Label text="本人確認書類が提出されました" />
        <Label text="確認手続きに３〜４営業日かかる場合がございます" />
        <Label text="承認確認までしばらくお待ち下さい" />
      </FlexColumn>
    </Container>
  )
}
